import React from 'react';

// react router component
import { useEffect, useRef, useState } from 'react';
import { Routes, Route, Outlet, useLocation } from 'react-router-dom';

// pages
import Login from './authentication/Login';
import AdminLogin from './authentication/AdminLogin';
import UnauthorizedPage from './pages/Unauthorized';

// Employee Master
import AddEmployee from './pages/HrMaster/EmployeeMaster/AddEmployee';
import ListEmployee from './pages/HrMaster/EmployeeMaster/ListEmployee';
import ViewEmployee from './pages/HrMaster/EmployeeMaster/ViewEmployee';

// Advance Payment
// import AdvancePayment from './pages/HrMaster/AdvancePayment/AdvancePaymentAdd';
import AdvancePaymentEdit from './pages/HrMaster/AdvancePayment/AdvancePaymentEdit';
import AdvancePaymentView from './pages/HrMaster/AdvancePayment/AdvancePaymentEdit';
import AdvancePaymentList from './pages/HrMaster/AdvancePayment/AdvancePaymentList';

// LeaveMaster
// import ApplyLeave from './pages/HrMaster/LeaveMaster/ApplyLeave';
import ApproveLeave from './pages/HrMaster/LeaveMaster/ApproveLeave';
import PayrollProcess from './pages/HrMaster/PayrollProcess';

// Project Master
import ProjectMasterAdd from './pages/ProjectMaster/ProjectMasterAdd';
import ProjectMasterList from './pages/ProjectMaster/ProjectMasterList';
import ProjectMasterEdit from './pages/ProjectMaster/ProjectMasterEdit';

// Client Master
import ClientMasterAdd from './pages/ClientMaster/ClientMasterAdd';
import ClientMasterList from './pages/ClientMaster/ClientMasterList';
import ClientMasterEdit from './pages/ClientMaster/ClientMasterEdit';

// PositionMaster
import AddPositons from './pages/OtherMasters/PositionMaster/AddPositionMaster';

//DepartmentMaster
import AddDepartments from './pages/OtherMasters/DepartmentMaster/AddDepartments';

//ContractorMaster
// import AddContract from "./pages/ContractorMaster/AddContractor";
// import ListContractor from "./pages/ContractorMaster/ListContractor";

//HolidayMaster
import AddHolidayDay from './pages/OtherMasters/HolidayMaster/AddHoliday';

//Pomaster
import PurchaseOrderCreate from './pages/VendorMaster/PoMaster/PurchaseOrder';
import PurchaseOrderView from './pages/VendorMaster/PoMaster/PurchaseOrderView';
import PurchaseOrderList from './pages/VendorMaster/PoMaster/PurchaceOrderList';
import PurchaseOrderEdit from './pages/VendorMaster/PoMaster/PurchaseOrderEdit';
import ProformaOrderList from './pages/VendorMaster/PoMaster/ProformaOrderList';
import ProformaOrderEdit from './pages/VendorMaster/PoMaster/ProformaOrderEdit';
import ProformaOrderView from './pages/VendorMaster/PoMaster/ProformaOrderView';

//VendorMaster
import VendorCreate from './pages/VendorMaster/VendorMaster/VendorCreate';
import VendorList from './pages/VendorMaster/VendorMaster/VendorList';
import VendorEdit from './pages/VendorMaster/VendorMaster/VendorEdit';

//PaymentRequestProject
import PaymentRequest from './pages/PaymentRequest/PaymentRequest';
import PaymentRequestApproval from './pages/PaymentRequest/PaymentRequestApproval';
import ListPaymentRequest from './pages/PaymentRequest/PaymentRequestList';
import PaymentRequestView from './pages/PaymentRequest/PaymentRequestView';

//Terms and Conditions
import TermsConditions from './pages/OtherMasters/TermsConditions/TermsConditions';
import TermsConditionsList from './pages/OtherMasters/TermsConditions/TermsConditionsList';
import TermsConditionsEdit from './pages/OtherMasters/TermsConditions/TermsConditionsEdit';

// Role Mater
import RequireAuth from './authentication/RequireAuth';

//Pay Slip
import PaySlip from './pages/PayslipMaster/PaySlip';
import PayslipReport from './pages/PayslipMaster/payslipReport';
import YearlyBonus from './pages/HrMaster/YearlyBonus';

//Allowances
import ManageAllowances from './pages/OtherMasters/ManageAllowances/ManageAllowances';
import ManageAllowancesAdd from './pages/OtherMasters/ManageAllowances/ManageAllowancesAdd.jsx';

//Attendance Master
import EmployeeAttendance from './pages/AttendanceMaster/employeeAttendance';
import EmployeeAttendanceReport from './pages/AttendanceMaster/employeeAttendanceReport';

// import LabourAttandence from './pages/UserMaster/LabourAttandence';
import LabourAttend from './pages/AttendanceMaster/labourAttendence';
//User Master
// import UserAttendance from './pages/UserMaster/UserAttendance';

//Dashboard
import Dashboard from './pages/Dashboard';
import PurchaseOrderDashboard from './pages/Dashboard/PurchaseOrderDashboard';
import PageNotFound from './pages/PageNotFound';

// Announcement
import Announcement from './pages/AnnouncementMaster/AnnouncementMaster.jsx';

// Weekly Report
import WeeklyReport from './pages/reports/WeeklyPaymentReport.jsx';
import WeeklyReport1 from './pages/reports/WeeklyPaymentReport1.jsx';
import WeeklyPlanSchedule from './pages/reports/weeklyPlanSchedule.jsx';
import WeeklyPlanScheduleView from './pages/reports/WeeklyPlanScheduleView.jsx';

// css
import './App.css';

// Other

import { userData, FrontentUrl } from './config';

//Test
import Pagination from './pages/Pagination';
import ProjectIncome from './pages/ProjectMaster/ProjectIncome';
import Invoice from './pages/InvoiceMaster/Invoice';
import ManageCoAdd from './pages/ManageCompanies/ManageCoAdd';
import InvoiceTermsCondition from './pages/InvoiceTermsAndConditions/InvoiceTermsCondition';
import InvoiceTermsConditionList from './pages/InvoiceTermsAndConditions/InvoiceTermsConditionList';
import ManageCoList from './pages/ManageCompanies/ManageCoList';
import ManageCoEdit from './pages/ManageCompanies/ManageCoEdit';
import InvoiceTermsConditionEdit from './pages/InvoiceTermsAndConditions/InvoiceTermsConditionEdit';
import InvoiceList from './pages/InvoiceMaster/InvoiceList';
import InvoiceView from './pages/InvoiceMaster/InvoiceView';
import ProjectSummaryReport from './pages/reports/ProjectSummaryReport';
import ProjectReport from './pages/reports/ProjectReport';
import LeaveReport from './pages/reports/LeaveReport';
import EmployeeActivityReport from './pages/reports/EmployeeActivityReport';
import AttendanceReport from './pages/reports/EmployeeAttendanceReport';
import ProjectPaymentReport from './pages/reports/ProjectPaymentReport';
import PoWorkOrderReport from './pages/reports/PoWorkOrderReport';
import LabourApproverSettings from './pages/reports/LabourApproverSettings.jsx';
import AdvanceReliefApproverSettings from './pages/reports/AdvanceReliefApproverSettings.jsx';
import PaymentApproverSettings from './pages/reports/PaymentApproverSettings.jsx';
import CashInHand from './pages/reports/CashInHand.jsx';
import AdvanceBalances from './pages/reports/AdvanceBalances.jsx';
import AllEmployeesAttendance from './pages/reports/AllEmployeesAttendance.jsx';
import PaymentRequestReview from './pages/PaymentRequest/PaymentRequestReview.jsx';
import WeeklyLabourApproval from './pages/reports/WeeklyLabourApproval.jsx';
import WeeklyLabourSheet from './pages/reports/WeeklyLabourSheet.jsx';

import Configuration from './pages/OtherMasters/ConfigurationMaster/Configuration';
import LabourWages from './pages/OtherMasters/ConfigurationMaster/LabourWages';
import LabourWagesEdit from './pages/OtherMasters/ConfigurationMaster/LabourWagesEdit';
import RoleMenuSettings from './pages/OtherMasters/ConfigurationMaster/RoleMenuSettings';
import CompanyModuleAccess from './pages/OtherMasters/ConfigurationMaster/CompanyModuleAccess';

import PaymentRequestList from './pages/PaymentRequest/PaymentRequestList';

import storeMasterAdd from './pages/OtherMasters/StoreMaster/StoreMasterAdd.jsx';
import StoreMasterAdd from './pages/OtherMasters/StoreMaster/StoreMasterAdd.jsx';
import StoreMasterList from './pages/OtherMasters/StoreMaster/StoreMasterList';
import StoreMasterEdit from './pages/OtherMasters/StoreMaster/StoreMasterEdit';
import InvoiceEdit from './pages/InvoiceMaster/InvoiceEdit';

const Layout = () => {
  return <Outlet />;
};

function App() {
  const [role, setRole] = useState('');
  const useRefApp = useRef(false);
  const location = useLocation();

  useEffect(() => {
    const isPoRoute = (location?.pathname || "").startsWith("/purchase-order") ||
      (window.location?.pathname || "").startsWith("/purchase-order");
    if (!isPoRoute) {
      localStorage.removeItem("filterData");
    }
  }, [location.pathname]);

  useEffect(() => {
    if (useRefApp.current === false) {
      const useData = JSON.parse(localStorage.getItem('user'));
      if (useData !== null) {
        setRole(useData.role);
      } else {
        if (
          ![FrontentUrl, FrontentUrl + '/adminlogin'].includes(
            window.location.origin
          )
        ) {
          // window.location.href = window.location.origin + "/"
        }
      }
    }
    return () => {
      useRefApp.current = true;
    };
  }, []);

  return (
    <Routes>
      {/* <Route path="*" component={PageNotFound} /> */}
      {/* <Route path="/" element={<Layout />}> */}
      <Route path='/' element={<Login />} />
      <Route path='adminlogin' element={<AdminLogin />} />
      <Route path='weeklyReport' element={<WeeklyReport />} />
      <Route path='weeklyReport1/:id' element={<WeeklyReport1 />} />
      <Route path='weeklyPlanSchedule' element={<WeeklyPlanSchedule />} />
      <Route
        path='weeklyPlanScheduleView/:id'
        element={<WeeklyPlanScheduleView />}
      />
      <Route path='unauthorized' element={<UnauthorizedPage />} />


      {userData === null ? (
        <></>
      ) : (
        <>
          {/* User Portal routes disabled in web app (handled in mobile app) */}
          {/* <Route path='user' element={<RequireAuth />}>
            <Route path='attendance' element={<UserAttendance />} />
            <Route path='labour-attandence' element={<LabourAttandence />} />
            <Route path='labour-attend' element={<LabourAttend />} />
            <Route path='payment/request' element={<PaymentRequest />} />
            <Route path='payment/list' element={<ListPaymentRequest />} />
            <Route path='apply-leave' element={<ApplyLeave />} />
          </Route> */}

          <Route path='dashboard' element={<Dashboard />}></Route>
          <Route path='purchase-work-order-dashboard' element={<PurchaseOrderDashboard />}></Route>
          <Route path='announcement' element={<Announcement />}></Route>
          <Route path='employee' element={<RequireAuth />}>
            <Route path='add' element={<AddEmployee />} />
            <Route path='list' element={<ListEmployee />} />
            <Route path='view/:employeeid' element={<ViewEmployee />} />
          </Route>

          <Route path='advance-payment' element={<RequireAuth />}>
            {/* <Route path="add" element={<AdvancePayment />} /> */}
            <Route
              path='edit/:paymentid'
              element={<AdvancePaymentEdit />}
            />
            <Route
              path='view/:paymentid'
              element={<AdvancePaymentView />}
            />
            <Route path='list' element={<AdvancePaymentList />} />
          </Route>

          <Route path='Leave' element={<RequireAuth />}>
            <Route path='approval' element={<ApproveLeave />} />
          </Route>

          <Route path='project' element={<RequireAuth />}>
            <Route path='add' element={<ProjectMasterAdd />} />
            <Route path='list' element={<ProjectMasterList />} />
            <Route path='edit/:projectid' element={<ProjectMasterEdit />} />
            <Route
              path='project-income/:projectid'
              element={<ProjectIncome />}
            />
          </Route>

          <Route path='client' element={<RequireAuth />}>
            <Route path='add' element={<ClientMasterAdd />} />
            <Route path='list' element={<ClientMasterList />} />
            <Route path='edit/:clientid' element={<ClientMasterEdit />} />
          </Route>

          <Route path='store' element={<RequireAuth />}>
            <Route path='add' element={<StoreMasterAdd />} />
            <Route path='list' element={<StoreMasterList />} />
            <Route path='edit/:storeId' element={<StoreMasterEdit />} />
          </Route>

          <Route path='payment' element={<RequireAuth />}>
            <Route path='request' element={<PaymentRequest />} />
            <Route path='list' element={<ListPaymentRequest />} />
            <Route path='approval' element={<PaymentRequestApproval />} />
            <Route
              path='admin/:status/:requestID'
              element={<PaymentRequestView />}
            />
            <Route path='review/:id' element={<PaymentRequestReview />} />
          </Route>

          <Route path='vendor' element={<RequireAuth />}>
            <Route path='create' element={<VendorCreate />} />
            <Route path='list' element={<VendorList />} />
            <Route path='edit/:vendorid' element={<VendorEdit />} />
          </Route>

          <Route path='purchase-order' element={<RequireAuth />}>
            <Route path='create' element={<PurchaseOrderCreate />} />
            <Route path='view/:poid' element={<PurchaseOrderView />} />
            <Route path='list' element={<PurchaseOrderList />} />
            <Route path='edit/:POid' element={<PurchaseOrderEdit />} />
          </Route>

          <Route path='material-receipt' element={<RequireAuth />}>
            <Route path='list' element={<ProformaOrderList />} />
            <Route path='edit/:id' element={<ProformaOrderEdit />} />
            <Route path='view/:id' element={<ProformaOrderView />} />
          </Route>

          <Route path='config' element={<RequireAuth />}>
            <Route path='positions-master' element={<AddPositons />} />
            <Route path='departments-master' element={<AddDepartments />} />
            <Route path='configuration' element={<Configuration />} />
            <Route path='labour-wages' element={<LabourWages />} />
            <Route
              path='labour-wages/edit/:labourId'
              element={<LabourWagesEdit />}
            />
            <Route
              path='role-menu-settings'
              element={<RoleMenuSettings />}
            />
            <Route
              path='company-module-access'
              element={<CompanyModuleAccess />}
            />
          </Route>
          <Route path='reports' element={<RequireAuth />}>
            <Route
              path='project-summary'
              element={<ProjectSummaryReport />}
            />
            <Route path='project-report' element={<ProjectReport />} />

            <Route path='leave-report' element={<LeaveReport />} />
            <Route
              path='employee-activity-report'
              element={<EmployeeActivityReport />}
            />
            <Route
              path='employee-attendance-report'
              element={<AttendanceReport />}
            />

            <Route
              path='project-payment-report'
              element={<ProjectPaymentReport />}
            />
            <Route
              path='po-work-order'
              element={<PoWorkOrderReport />}
            />
          </Route>

          <Route path='weekly-labour-approval' element={<RequireAuth />}>
            <Route path='' element={<WeeklyLabourApproval />} />
          </Route>
          <Route path='labour-approver-settings' element={<RequireAuth />}>
            <Route path='' element={<LabourApproverSettings />} />
          </Route>
          <Route path='advance-relief-approver-settings' element={<RequireAuth />}>
            <Route path='' element={<AdvanceReliefApproverSettings />} />
          </Route>
          <Route path='payment-approver-settings' element={<RequireAuth />}>
            <Route path='' element={<PaymentApproverSettings />} />
          </Route>
          <Route path='cash-in-hand' element={<RequireAuth />}>
            <Route path='' element={<CashInHand />} />
          </Route>
          <Route path='weekly-labour-sheet' element={<RequireAuth />}>
            <Route path='' element={<WeeklyLabourSheet />} />
          </Route>
          <Route path='termsandconditions' element={<RequireAuth />}>
            <Route path='add' element={<TermsConditions />} />
            <Route path='list' element={<TermsConditionsList />} />
            <Route path='edit/:termsID' element={<TermsConditionsEdit />} />
          </Route>

          <Route path='add-holiday' element={<RequireAuth />}>
            <Route path='' element={<AddHolidayDay />} />
          </Route>
          <Route path='payslip' element={<RequireAuth />}>
            <Route path=':employee_id?/:date?' element={<PaySlip />} />
          </Route>
          <Route path='payslip-report' element={<RequireAuth />}>
            <Route path='' element={<PayslipReport />} />
          </Route>
          <Route path='payroll-process' element={<RequireAuth />}>
            <Route path='' element={<PayrollProcess />} />
          </Route>
          <Route path='yearly-bonus' element={<RequireAuth />}>
            <Route path='' element={<YearlyBonus />} />
          </Route>
          <Route path='manage-allowances' element={<RequireAuth />}>
            <Route path='' element={<ManageAllowances />} />
          </Route>
          <Route path='manage-allowances-add' element={<RequireAuth />}>
            <Route path='' element={<ManageAllowancesAdd />} />
            <Route path=':id' element={<ManageAllowancesAdd />} />
          </Route>
          <Route path='employee-attendance' element={<RequireAuth />}>
            <Route path='' element={<EmployeeAttendance />} />
          </Route>
          <Route path='employee-attendance-report' element={<RequireAuth />}>
            <Route path=':id' element={<EmployeeAttendanceReport />} />
          </Route>
          <Route path='pagination' element={<Pagination />} />

          <Route path='manage-companies' element={<RequireAuth />}>
            <Route path='add' element={<ManageCoAdd />} />
            <Route path='list' element={<ManageCoList />} />
            <Route path='edit/:companyId' element={<ManageCoEdit />} />
          </Route>

          <Route path='invoice' element={<RequireAuth />}>
            <Route path='create' element={<Invoice />} />
            <Route path='list' element={<InvoiceList />} />
            <Route path='view/:poid' element={<InvoiceView />} />
            <Route path='edit/:IOid' element={<InvoiceEdit />} />
          </Route>

          <Route path='invoiceTermsAndConditions' element={<RequireAuth />}>
            <Route path='add' element={<InvoiceTermsCondition />} />
            <Route path='list' element={<InvoiceTermsConditionList />} />
            <Route
              path='edit/:termsID'
              element={<InvoiceTermsConditionEdit />}
            />
          </Route>

          <Route path='payment-request' element={<RequireAuth />}>
            <Route path='list' element={<PaymentRequestList />} />
          </Route>
        </>
      )}
      {/* </Route> */}
    </Routes>
  );
}

export default App;
